import * as _ from 'lodash';
import * as moment from 'moment';
import { FormEvent, useEffect, useState } from 'react';
import { Alert, Button, Col, ControlLabel, FormControl, Label, Panel, Radio, Row } from 'react-bootstrap';
import { FormGroupWrapper, ViewWrapper } from './styles';
import { IRecipientForSidebar, IRecipientSearchReportLookupData } from '@nkr/models/index';
import { MatchStatus } from '@nkr/enums/index';
import MaskedInput from 'react-maskedinput';
import AllowDuplicateControl from '@nkr/views/allow-duplicate/allow-duplicate-control';
import { EntityType } from '@nkr/enums/entity-type';

interface IProps {
    centerId: number,
    isSuper: boolean,
    data: IRecipientForSidebar,
    lookupData: IRecipientSearchReportLookupData,
    onDataChange: (data: IRecipientForSidebar) => void,
    onSave: () => void,
}

const View = (props: IProps) => {
    const [birthDateValid, setBirthDateValid] = useState(true);
    const [registrationDateValid, setRegistrationDateValid] = useState(true);
    const [dirty, setDirty] = useState(false);

    useEffect(() => {
        if (props.data == null) {
            setBirthDateValid(true);
            setRegistrationDateValid(true);
            setDirty(false);
        }
    }, [props.data]);

    const validate = () => {
        let { dateRegistered, birthDate } = props.data;

        return {
            newRegistrationDateValid: dateRegistered != '',
            newBirthDateValid: moment(birthDate).isValid()
        };
    };

    const handleFieldChange = (e: FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => {
        let id = e.currentTarget.id;
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;
        let data = _.cloneDeep(props.data);

        if (id == 'center') {
            data.centerId = parseInt(value);
        }

        if (id == 'alias') {
            data.alias = value;
        }

        if (id == 'firstName') {
            data.firstName = value;
        }

        if (id == 'lastName') {
            data.lastName = value;
        }

        if (id == 'email') {
            data.email = value;
        }

        if (id == 'mrn') {
            data.mrn = value;
        }

        if (id == 'dateRegistered') {
            data.dateRegistered = value;
        }

        if (id == 'firstExportableDate') {
            data.firstExportableDate = value;
        }

        if (id == 'inactiveReason') {
            data.inactiveReason = parseInt(value);
        }

        if (id == 'patientTypeId') {
            data.patientTypeId = parseInt(value);
        }

        if (id == 'birthDate') {
            data.birthDate = value;
        }

        if (id == 'chainNumber') {
            data.chainNumber = parseInt(value);
        }

        if (id == 'clusterNumber') {
            data.clusterNumber = parseInt(value);
        }

        if (id == 'position') {
            data.position = parseInt(value);
        }

        if (id == 'statusId') {
            data.statusId = parseInt(value);
        }

        if (name == 'isSwapSaver') {
            data.isSwapSaver = value == '1';
        }

        if (name == 'isRealTimeSwapFailure') {
            data.isRealTimeSwapFailure = value == '1';
        }

        if (name == 'isActive') {
            data.isActive = value == '1';
        }

        if (name == 'isDeleted') {
            data.isDeleted = value == '1';
        }

        if (name == 'sendComplianceEmails') {
            data.sendComplianceEmails = value == '1';
        }

        // if (name == 'patientIsTargetedChainEnd') {
        //     data.targetedChainEnd = value == '1';
        // }

        if (name == 'bloodType') {
            data.bloodType = value;
        }

        if (name == 'gender') {
            data.gender = value;
        }

        props.onDataChange(data);
    };

    const handleSave = () => {
        let { newRegistrationDateValid, newBirthDateValid } = validate();
        let isValid = newRegistrationDateValid && newBirthDateValid;

        setRegistrationDateValid(newRegistrationDateValid);
        setBirthDateValid(newBirthDateValid);
        setDirty(true);

        if (isValid) {
            props.onSave();
        }
    };

    if (props.data == null || props.lookupData == null)
        return null;

    const isValid = dirty ? registrationDateValid && birthDateValid : true;
    // const showSwapSelections = props.data.patientTypeId == PatientType.StandardVoucherHolder || props.data.patientTypeId == PatientType.FamilyVoucherHolder;

    return (
        <>
            <ViewWrapper horizontal>
                <div className='modal-container'>
                    {!isValid && (
                        <div className='row'>
                            <div className='col-xs-12 col-lg-12'>
                                <Alert bsStyle='danger'>
                                    Please fill out all required fields below. <br /> Please ensure data is valid.
                                </Alert>
                            </div>
                        </div>
                    )}

                    <div className='row' style={{ height: '10px' }}> </div>

                    <Panel>
                        <Panel.Body style={{ padding: '10px 5px' }}>
                            <FormGroupWrapper>
                                <Col xs={12} lg={5} componentClass={ControlLabel}>Alias:</Col>
                                <Col xs={12} lg={7}>
                                    <FormControl
                                        id='alias'
                                        style={{ width: 200 }}
                                        value={props.data.alias}
                                        onChange={handleFieldChange}
                                    />
                                </Col>
                            </FormGroupWrapper>

                            <FormGroupWrapper>
                                <Col xs={12} lg={5} componentClass={ControlLabel}>First Name:</Col>
                                <Col xs={12} lg={7}>
                                    <FormControl
                                        id='firstName'
                                        style={{ width: 200 }}
                                        value={props.data.firstName}
                                        onChange={handleFieldChange}
                                    />
                                </Col>
                            </FormGroupWrapper>

                            <FormGroupWrapper>
                                <Col xs={12} lg={5} componentClass={ControlLabel}>Last Name:</Col>
                                <Col xs={12} lg={7}>
                                    <FormControl
                                        id='lastName'
                                        style={{ width: 200 }}
                                        value={props.data.lastName}
                                        onChange={handleFieldChange}
                                    />
                                </Col>
                            </FormGroupWrapper>

                            <FormGroupWrapper>
                                <Col xs={12} lg={5} componentClass={ControlLabel}>Email:</Col>
                                <Col xs={12} lg={7}>
                                    <FormControl
                                        id='email'
                                        // style={{ width: 200 }}
                                        value={props.data.email}
                                        onChange={handleFieldChange}
                                    />
                                </Col>
                            </FormGroupWrapper>

                            <FormGroupWrapper>
                                <Col xs={12} lg={5} componentClass={ControlLabel}>MRN:</Col>
                                <Col xs={12} lg={7}>
                                    <FormControl
                                        id='mrn'
                                        style={{ width: 200 }}
                                        value={props.data.mrn}
                                        onChange={handleFieldChange}
                                    />
                                </Col>
                            </FormGroupWrapper>

                            <FormGroupWrapper>
                                <Col xs={12} lg={5} componentClass={ControlLabel}>Patient Type:</Col>
                                <Col xs={12} lg={7}>
                                    <FormControl
                                        componentClass='select'
                                        id='patientTypeId'
                                        value={props.data.patientTypeId}
                                        onChange={handleFieldChange}
                                        disabled
                                    >
                                        {props.lookupData.patientTypeList.map((item, index) =>
                                            <option key={'pt-' + index} value={item.id}>{item.description}</option>
                                        )}
                                    </FormControl>
                                </Col>
                            </FormGroupWrapper>

                            {/* {props.data.patientTypeId == PatientType.StandardVoucherHolder && (
                                <FormGroupWrapper>
                                    <Col xs={12} lg={5} componentClass={ControlLabel}>Is Swap Saver?</Col>
                                    <Col xs={12} lg={7}>
                                        <Radio inline id='isSwapSaverYes' name='isSwapSaver' disabled={!showSwapSelections} value={1} checked={props.data.isSwapSaver} onChange={handleFieldChange}>Yes</Radio>
                                        <Radio inline id='isSwapSaverNo' name='isSwapSaver' disabled={!showSwapSelections} value={0} checked={!props.data.isSwapSaver} onChange={handleFieldChange}>No</Radio>
                                    </Col>
                                </FormGroupWrapper>
                            )} */}

                            {/* {props.data.patientTypeId == PatientType.StandardVoucherHolder && (
                                <FormGroupWrapper>
                                    <Col xs={12} lg={5} componentClass={ControlLabel}>Is Real Time Swap Failure?</Col>
                                    <Col xs={12} lg={7}>
                                        <Radio inline id='isRealTimeSwapFailureYes' name='isRealTimeSwapFailure' disabled={!showSwapSelections} value={1} checked={props.data.isRealTimeSwapFailure} onChange={handleFieldChange}>Yes</Radio>
                                        <Radio inline id='isRealTimeSwapFailureNo' name='isRealTimeSwapFailure' disabled={!showSwapSelections} value={0} checked={!props.data.isRealTimeSwapFailure} onChange={handleFieldChange}>No</Radio>
                                    </Col>
                                </FormGroupWrapper>
                            )} */}

                            <FormGroupWrapper>
                                <Col xs={12} lg={5} componentClass={ControlLabel}>Status:</Col>
                                <Col xs={12} lg={7}>
                                    <FormControl
                                        componentClass='select'
                                        id='statusId'
                                        value={props.data.statusId}
                                        onChange={handleFieldChange}
                                        disabled
                                    >
                                        {props.lookupData.matchStatusList.map((item, index) =>
                                            <option key={'sl-' + index} value={item.id}>{item.description}</option>
                                        )}
                                    </FormControl>
                                </Col>
                            </FormGroupWrapper>

                            <FormGroupWrapper validationState={dirty && !registrationDateValid ? 'error' : null}>
                                <Col xs={12} lg={5} componentClass={ControlLabel}>Registration Date:</Col>
                                <Col xs={12} lg={7}>
                                    <div className='form-control-static'>{props.data.dateRegistered ?? '--'}</div>
                                </Col>
                            </FormGroupWrapper>

                            <FormGroupWrapper>
                                <Col xs={12} lg={5} componentClass={ControlLabel}>First Exportable Date:</Col>
                                <Col xs={12} lg={7}>
                                    <div className='form-control-static'>{props.data.firstExportableDate != '' ? props.data.firstExportableDate : '--'}</div>
                                </Col>
                            </FormGroupWrapper>

                            {props.data.statusId == MatchStatus.Transplanted && (
                                <FormGroupWrapper>
                                    <Col xs={12} lg={5} componentClass={ControlLabel}>Transplant Date:</Col>
                                    <Col xs={12} lg={7}>
                                        <div className='form-control-static'>{props.data.transplantDate}</div>
                                    </Col>
                                </FormGroupWrapper>
                            )}

                            {props.data.chainNumber > 0 && (
                                <FormGroupWrapper>
                                    <Col xs={12} lg={5} componentClass={ControlLabel}>Swap:</Col>
                                    <Col xs={12} lg={7}>
                                        <div className='form-control-static'>{props.data.chainNumber}/{props.data.clusterNumber}/{props.data.position}</div>
                                    </Col>
                                </FormGroupWrapper>
                            )}

                            <FormGroupWrapper>
                                <Col xs={12} lg={5} componentClass={ControlLabel}>Blood Type:</Col>
                                <Col xs={12} lg={7}>
                                    <div className='form-control-static'>{props.data.bloodType}</div>
                                </Col>
                            </FormGroupWrapper>

                            <FormGroupWrapper>
                                <Col xs={12} lg={5} componentClass={ControlLabel}>Patient is Exportable?</Col>
                                <Col xs={12} lg={7}>
                                    <div className='form-control-static'>{props.data.isExportable ? <Label bsStyle="success">Yes</Label> : <Label bsStyle="danger">No</Label>}</div>
                                </Col>
                            </FormGroupWrapper>

                            <FormGroupWrapper>
                                <Col xs={12} lg={5} componentClass={ControlLabel}>Patient is Active?</Col>
                                <Col xs={12} lg={7}>
                                    <div style={{ height: 34 }}>
                                        <Radio inline id='isActiveYes' name='isActive' value={1} checked={props.data.isActive} onChange={handleFieldChange}>Yes</Radio>
                                        <Radio inline id='isActiveNo' name='isActive' value={0} checked={!props.data.isActive} onChange={handleFieldChange}>No</Radio>
                                    </div>
                                </Col>
                            </FormGroupWrapper>

                            {!props.data.isActive && (
                                <FormGroupWrapper>
                                    <Col xs={12} lg={5} componentClass={ControlLabel}>Inactive Reasons</Col>
                                    <Col xs={12} lg={7}>
                                        <FormControl
                                            componentClass='select'
                                            id='inactiveReason'
                                            value={props.data.inactiveReason}
                                            onChange={handleFieldChange}
                                        >
                                            {props.lookupData.recipientInactiveReasonList.map((item, index) =>
                                                <option key={'inact-' + index} value={item.id}>{item.description}</option>
                                            )}
                                        </FormControl>
                                    </Col>
                                </FormGroupWrapper>
                            )}

                            <FormGroupWrapper>
                                <Col xs={12} lg={5} componentClass={ControlLabel}>Recipient is Deleted?</Col>
                                <Col xs={12} lg={7}>
                                    <div style={{ height: 34 }}>
                                        <div style={{ height: 34 }}>
                                            <Radio inline id='isDeletedYes' name='isDeleted' value={1} checked={props.data.isDeleted} onChange={handleFieldChange}>Yes</Radio>
                                            <Radio inline id='isDeletedNo' name='isDeleted' value={0} checked={!props.data.isDeleted} onChange={handleFieldChange}>No</Radio>
                                        </div>
                                    </div>
                                </Col>
                            </FormGroupWrapper>

                            {props.isSuper &&
                                <FormGroupWrapper>
                                    <Col xs={12} lg={5} componentClass={ControlLabel}>Allow Duplicate:</Col>
                                    <Col xs={12} lg={7}>
                                        <AllowDuplicateControl entityType={EntityType.Recipient} profileId={props.data.id} />
                                    </Col>
                                </FormGroupWrapper>
                            }

                            <FormGroupWrapper>
                                <Col xs={12} lg={5} componentClass={ControlLabel}>Send Compliance E-mails?</Col>
                                <Col xs={12} lg={7}>
                                    <div style={{ height: 34 }}>
                                        <Radio inline id='sendComplianceEmailsYes' name='sendComplianceEmails' value={1} checked={props.data.sendComplianceEmails} onChange={handleFieldChange}>Yes</Radio>
                                        <Radio inline id='sendComplianceEmailsNo' name='sendComplianceEmails' value={0} checked={!props.data.sendComplianceEmails} onChange={handleFieldChange}>No</Radio>
                                    </div>
                                </Col>
                            </FormGroupWrapper>

                            {/* <FormGroupWrapper>
                                <Col xs={12} lg={5} componentClass={ControlLabel}>Patient is Targeted Chain End?</Col>
                                <Col xs={12} lg={7}>
                                    <Radio inline id='patientIsTargetedChainEndYes' name='patientIsTargetedChainEnd' value={1} checked={props.data.targetedChainEnd != null ? props.data.targetedChainEnd : false} onChange={handleFieldChange}>Yes</Radio>
                                    <Radio inline id='patientIsTargetedChainEndNo' name='patientIsTargetedChainEnd' value={0} checked={props.data.targetedChainEnd != null ? !props.data.targetedChainEnd : false} onChange={handleFieldChange}>No</Radio>
                                </Col>
                            </FormGroupWrapper> */}

                            <FormGroupWrapper>
                                <Col xs={12} lg={5} componentClass={ControlLabel}>Gender</Col>
                                <Col xs={12} lg={7}>
                                    <div style={{ height: 34 }}>
                                        <Radio inline id='genderM' name='gender' value={'M'} checked={props.data.gender == 'M'} onChange={handleFieldChange}>Male</Radio>
                                        <Radio inline id='genderF' name='gender' value={'F'} checked={props.data.gender == 'F'} onChange={handleFieldChange}>Female</Radio>
                                    </div>
                                </Col>
                            </FormGroupWrapper>

                            <FormGroupWrapper validationState={dirty && !birthDateValid ? "error" : null}>
                                <Col xs={12} lg={5} componentClass={ControlLabel}>Birth Date:</Col>
                                <Col xs={12} lg={7}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div style={{ marginRight: 5 }}>
                                            <MaskedInput
                                                id='birthDate'
                                                mask='11/11/1111'
                                                placeholder='mm/dd/yyyy'
                                                className='form-control'
                                                value={props.data.birthDate}
                                                onChange={handleFieldChange} />
                                        </div>
                                    </div>
                                </Col>
                            </FormGroupWrapper>
                        </Panel.Body>
                    </Panel>

                    <div style={{ textAlign: 'center' }}>
                        <Button bsStyle='primary' bsSize='large' onClick={handleSave}>Save Changes</Button>
                    </div>

                    <div className='row' style={{ marginTop: 0, marginBottom: 10, height: 10 }}></div>
                </div>
            </ViewWrapper>
        </>
    );
}

export default View;